import React from "react";
import LegalLayout from "./_LegalLayout";

const H = ({ children }) => (
  <h2 className="font-display text-xl sm:text-2xl font-semibold text-ink-900 tracking-tight mt-8">
    {children}
  </h2>
);

const Security = () => (
  <LegalLayout
    testId="page-security"
    overline="Legal · Security"
    title="Security & Responsible Disclosure"
    lead="If you believe you have identified a security issue affecting the Allinstra website, please contact us."
  >
    <H>Reporting a security issue</H>
    <p>
      Contact:{" "}
      <a href="mailto:info@allinstra.com" className="underline">info@allinstra.com</a>
    </p>

    <H>Responsible disclosure principles</H>
    <p>Please:</p>
    <ul className="list-disc pl-5 space-y-1.5">
      <li>do not exploit a vulnerability;</li>
      <li>do not access data without authorisation;</li>
      <li>do not disrupt services or impair availability;</li>
      <li>do not conduct harmful or unlawful testing.</li>
    </ul>

    <p>Good-faith, responsible disclosure is appreciated.</p>
  </LegalLayout>
);

export default Security;
